import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
import { ParmedApiService as ParmedApi } from '../../core/api/parmed-api.service';
import { UserService } from '../../core/services/user.service';
import { StaticConstants } from '../../core/constants/static.constants';
import { CreditCard } from '../../shared/models/credit-card';
import {
  AccountProperty,
  CacheConstant
} from '../../core/constants/app.constant';
import { PublisherService } from '../../core/services/publisher.service';
import { AppUtilService } from '../../core/utils/app-util.service';
import { execute } from '../products/products.service-helper';
import { AppConfigService } from '../../core/services/init/app-config.service';
declare var $XIPlugin: any;

@Injectable()
export class CreditCardsService {
  /***************Properties***************/
  /***************Constructor***************/
  constructor(
    private http: HttpService,
    private userService: UserService,
    private api: ParmedApi,
    private configService: AppConfigService
  ) {}
  /***************Constructor***************/

  /***************Helper Methods***************/

  getStates(): Array<any> {
    const states: Array<any> = [];
    const cardStates = AppUtilService.static.typeRef.byGroup(
      StaticConstants.TypeGroup.State
    );

    cardStates.forEach(state => {
      const s = state.typeDesc.split('-');
      states.push({ name: s[0], value: s[1] });
    });

    return states;
  }

  isValidDate(cardMonth: string, cardYear: string): boolean {
    const month = cardMonth.toString().toNumber();
    const year = (
      '20' +
      cardYear
        .toString()
        .toNumber()
        .padStart(2, 0)
    ).toNumber();

    const currentDate = new Date();
    const cardExpirationDate = new Date(year, month);
    return currentDate.getTime() >= cardExpirationDate.getTime();
  }

  addTemporary(creditCard: CreditCard) {
    creditCard.isTemporary = true;
    let tempCards = AppUtilService.cache.get(
      CacheConstant.Temp_Credit_Cards
    ) as Array<CreditCard>;

    tempCards = !tempCards ? [] : tempCards;
    tempCards.push(creditCard);

    AppUtilService.cache.set(CacheConstant.Temp_Credit_Cards, tempCards);
  }

  deleteTemporary(creditCard: CreditCard) {
    const tempCards = AppUtilService.cache.get(
      CacheConstant.Temp_Credit_Cards
    ) as Array<CreditCard>;

    if (tempCards && tempCards.length > 0) {
      const tempCard = tempCards.find(card => card.token === creditCard.token);
      const cardIndex = tempCards.indexOf(tempCard);
      tempCards.splice(cardIndex, 1);

      AppUtilService.cache.set(CacheConstant.Temp_Credit_Cards, tempCards);
    }
  }

  /***************Helper Methods***************/

  /***************Service Methods***************/

  getAll() {
    const payerId = this.userService.getDefaultAccount()[
      AccountProperty.PayerId
    ];
    return execute(
      this.http,
      this.api.Config.GET_CREDIT_CARDS_URL,
      { payerId: payerId }, undefined, this.configService
    );
  }

  add(card: CreditCard) {
    const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();
    card.soldToNum = defaultAccount.soldToNum;
    card.shipToNum = defaultAccount.shipToNum;
    return this.http.post(this.api.Config.ADD_CREDIT_CARD_URL, card);
  }

  update(card: CreditCard) {
    const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();
    card.soldToNum = defaultAccount.soldToNum;
    card.shipToNum = defaultAccount.shipToNum;
    return this.http.post(this.api.Config.UPDATE_CREDIT_CARD_URL, card);
  }

  delete(card: CreditCard) {
    const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();
    card.soldToNum = defaultAccount.soldToNum;
    card.shipToNum = defaultAccount.shipToNum;
    return this.http.post(this.api.Config.DELETE_CREDIT_CARD_URL, card);
  }

  getAccessToken() {
    return this.http.get(this.api.Config.GET_ACCESS_TOKEN_URL);
  }

  getPaypalTokenDetails(){
    return this.http.get(this.api.Config.GET_PAYPAL_TOKEN_DETAILS_URL);
  }

  getResponsePacket(accessToken) {
    const body = { data: accessToken };
    return this.http.post(
      this.api.Config.GET_RESPONSE_PACKET_URL,
      JSON.stringify(body)
    );
  }

  callPaymetricAjax(accessToken: string, creditCardNumber: number) {
    const merchantGUID = AppUtilService.static.appPreference.get(
      StaticConstants.AppPreference.MERCHANT_GUID
    ).preferenceValue;

    const XiInterceptURL = AppUtilService.static.appPreference.get(
      StaticConstants.AppPreference.XIINTERCEPT_URL
    ).preferenceValue;

    const myData = $XIPlugin.createJSRequestPacket(merchantGUID, accessToken);
    myData.addField($XIPlugin.createField('CCNumber', true, creditCardNumber));

    $XIPlugin.ajax({
      url: XiInterceptURL + '/DIeComm/Ajax',
      type: 'POST',
      data: myData,
      success: function(response) {
        PublisherService.notifyAjaxSuccess(true);
      },
      error: function(a) {
        PublisherService.notifyAjaxSuccess(false);
      }
    });
  }

  /***************Service Methods***************/
}
